import React from 'react';
import DownloadAppSection from '../components/DownloadAppSection';

const Download = () => (
    <div>
        <DownloadAppSection />
    </div>
);

export default Download;
